import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { getDoctorsList, getDoctorSpecialities } from "../../api/Doctor";
import Loader from "../../customJS/Loader";
import { useDispatch } from "react-redux";
import { middleware } from "../../RTK/middleware";
import { dispatchConst } from "../../RTK/type";
import useAuthService from "../../session/useAuthService";
import moment from "moment-timezone";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Dropdown, Empty, Pagination } from "antd";
import { chipColor, getResourceThumbnail } from "../../customJS/custom.js";
import { userBlockOrUnblock } from "../../api/User.js";

export const DoctorList = () => {
  // const [doctorSpecialities, setDoctorSpecialities] = useState();
  const [loader, setLoader] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [additionalCount, setAdditionalCount] = useState({});
  const [paginationCount, setPaginationCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  // const doctorSpecialities = useSelector(({ main }) => main.specialities);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("paginationCount:::", paginationCount);
    getSpeciality();
  }, []);

  useEffect(() => {
    getDoctorsLists();
  }, [currentPage]);

  const getSpeciality = () => {
    setLoader(true);
    getDoctorSpecialities({})
      .then((response) => {
        if (response.data.status === 1) {
          dispatch(
            middleware({
              data: response.data.data,
              dispatchType: dispatchConst.specialities,
            })
          );
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const getDoctorsLists = () => {
    let obj = {
      hospitalId:
        useAuthService.getUserType() === "1"
          ? 0
          : useAuthService.getHospitalId(),
      pageNo: currentPage,
      flag: "A,R",
      userType: useAuthService.getUserType(),
    };
    setLoader(true);
    getDoctorsList(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log(response.data.data);
          setDoctorsList(response.data.data.doctorsLists);
          setAdditionalCount(response.data.data.additionalCount);
          console.log("additionalCount:::", response.data.data.additionalCount);
          setPaginationCount(response.data.data.totalCount);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const blockUser = (userId) => {
    let obj = { userId: userId, flag: "D" };
    setLoader(true);
    userBlockOrUnblock(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data);
          getDoctorsLists();
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const handleMenuClick = (e, userId, doctorId) => {
    if (e.key === "1") {
      if (userId) {
        openUserInNewTab(userId);
      }
    } else if (e.key === "2") {
      console.log(
        `Menu item ${e.key} clicked for doctor ID: ${(userId, doctorId)}`
      );

      if(useAuthService.getUserType() === "1"){
        navigate(`/admin/editDoctor/`, {
          state: { userId: userId, doctorId: doctorId },
        });
      }else{
        navigate(`/clinic/editDoctor/`, {
          state: { userId: userId, doctorId: doctorId },
        });
      }
     

      // alert("Edit Doctor");
    } else if (e.key === "3") {
      blockUser(userId);
      // alert("Block Doctor")
    }
    // You can add your specific logic here based on e.key (e.g., "1" for Edit Profile)
  };

  const openUserInNewTab = (userId) =>{
    const url = `${
      window.location.origin
    }/United/doctorProfile/Preview?userId=${btoa(userId)}`;
    window.open(url, "_blank");
  }

  const items = (userId, doctorId, flag) => {
    const menuItems = [
      {
        label: "View Profile",
        key: "1",
        icon: (
          <Icon
            icon="lets-icons:view-light"
            width="24"
            height="24"
            style={{ color: "#000" }}
          />
        ),
        onClick: (e) => handleMenuClick(e, userId),
      },
      {
        label: "Edit Profile",
        key: "2",
        icon: (
          <Icon
            icon="basil:user-outline"
            width="24"
            height="24"
            style={{ color: "#000" }}
          />
        ),
        onClick: (e) => handleMenuClick(e, userId, doctorId),
      },
    ];
  
    if (flag !== "R") {
      menuItems.push({
        label: "Block Account",
        key: "3",
        icon: <Icon icon="basil:user-block-outline" width="24" height="24" />,
        danger: true,
        onClick: (e) => handleMenuClick(e, userId),
      });
    }
  
    return menuItems;
  };

  const menuProps = (userId, doctorId, flag) => ({
    items: items(userId, doctorId, flag),
  });

  const onPageChange = (newCurrent) => {
    setCurrentPage(newCurrent - 1);
  };

  return (
    <Row className="m-0">
      {loader && <Loader />}
      <Col xs="12">
        {(useAuthService.getUserType() === "2" || useAuthService.getUserType() === "1")  && (
          <div className="d-flex justify-content-between align-items-center m-4">
            <h2 className="d-inline uniteColor font-weight700">
              {" "}
              Provider List
            </h2>
            <Link className="uniteButton-lg" to={useAuthService.getUserType() === "1" ? "/admin/addProvider" : "/clinic/addProvider"}>
            <Icon icon="fontisto:doctor" width="21" height="24" /> {" "} Add Provider
            </Link>
          </div>
        )}

        {useAuthService.getUserType() === "1" && (
          <Row className="mb-5" lg={6}>
            <Col lg={3}>
              <Card className="topCart">
                <Card.Body>
                  <Card.Title>
                    <h4>{additionalCount?.totalDoctors ?? 0}</h4>
                  </Card.Title>
                  <Card.Text>
                    <b>Total Providers</b>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className="topCart">
                <Card.Body>
                  <Card.Title>
                    <h4>{additionalCount?.activeDoctors ?? 0}</h4>
                  </Card.Title>
                  <Card.Text>
                    <b>Active Providers</b>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className="topCart">
                <Card.Body>
                  <Card.Title>
                    <h4>{additionalCount?.requestDoctors ?? 0}</h4>
                  </Card.Title>
                  <Card.Text>
                    <b>Request Providers</b>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className="topCart">
                <Card.Body>
                  <Card.Title>
                    <h4>{additionalCount?.blockedDoctors ?? 0}</h4>
                  </Card.Title>
                  <Card.Text>
                    <b>Blocked Providers</b>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Col>
      <Col xs="12" className="table-width table-responsive">
        {doctorsList.length === 0 ? (
          <Empty />
        ) : (
          <Table className="unitedTable" hover>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Speciality</th>
                {useAuthService.getUserType() === "1" && <th>Provider</th>}
                <th>Email</th>
                <th>Phone</th>
                <th>Joined date</th>
                {/* <th>Last logged</th> */}
                {useAuthService.getUserType() === "2" && (
                    <th>Status</th>
                )}

                <th></th>
              </tr>
            </thead>
            <tbody>
              {doctorsList?.map((doctor) => (
                <tr key={doctor.doctorId}>
                  <td align="center">
                    {doctor.image ? (
                      getResourceThumbnail(doctor.image)
                    ) : (
                      <Icon
                        icon={
                          doctor.gender === "FEMALE"
                            ? "et:profile-female"
                            : "et:profile-male"
                        }
                        width="30"
                        height="30"
                        style={{ color: "#0D224E" }}
                      />
                    )}
                    {/* { getResourceThumbnail(doctor.image)} */}
                  </td>
                  <td>{doctor.displayName}</td>
                  <td>{doctor.specialityName}</td>
                  {useAuthService.getUserType() === "1" && (
                    <td>{doctor.hospitalName}</td>
                  )}
                  <td>{doctor.mailId}</td>
                  <td>{doctor.phoneNo}</td>
                  <td>
                    {moment(doctor.createdDate, "YYYY-MM-DD HH:mm").format(
                      "MMMM D, YYYY"
                    )}
                  </td>
                  {/* <td>
                    {doctor.lastLogin === "0000-00-00 00:00"
                      ? "No login data"
                      : moment(doctor.lastLogin, "YYYY-MM-DD HH:mm").format(
                          "MMMM D, YYYY"
                        )}
                  </td> */}

                  {useAuthService.getUserType() === "2" && (
                      <td>
                        <span
                          className={"status-chip " + chipColor(doctor?.flag)}
                        >
                          {doctor.flag === "A" ? "APPROVED" : "REQUESTED"}
                        </span>
                      </td>
                  )}
                  <td>
                        <Dropdown
                          menu={menuProps(doctor.userId, doctor.doctorId, doctor.flag)}
                        >
                          <Button className="icon-btn">
                            <Icon
                              icon="qlementine-icons:menu-dots-16"
                              width="26"
                              height="26"
                              style={{ color: "#000" }}
                            />
                          </Button>
                        </Dropdown>
                      </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
      {paginationCount > 12 && (
        <Col className="mt-3">
          <Pagination
            current={currentPage + 1}
            defaultCurrent={1}
            total={paginationCount}
            defaultPageSize={12}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </Col>
      )}
    </Row>
  );
};
